import BrandingModel from "../../../../Global/Models/Branding/BrandingModel";
import ImagesModel from "../../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import { AuthRequirementType } from "../../../../Global/Types/GlobalTypes";
import ContextModel from "../../../Activity/Models/RequestBody/Context/ContextModel";
import PollOptionModel from "./PollOptionModel";

export default class PollBasicModel {
  public id: string = null;
  public title: string = null;
  public alternativeTitle: string = null;
  public description: string = null;
  public type: string = null;
  public images: ImagesModel = new ImagesModel();
  public status: string = null;
  public language: string = null;
  public authRequirement: AuthRequirementType = null;
  public totalVotes: number = null;
  public flags: string[] = [];
  public customFields: Record<string, string> = null;
  public branding: BrandingModel = null;
  public embedCode: string = null;
  public labels: Record<string, string> = null;
  public adContent: string = null;
  public context: ContextModel = null;
  public options: PollOptionModel[] = [];
  public related: RelatedEntityRelationship[] = [];
  public preferencesEnabled: boolean = false;
  public multipleChoice: boolean = false;
  public maxMultipleChoiceOptions: number | null = null;
  public participationCount: number = 0;
  public maxAttempts: number | null = 0;
  public externalActivity: string | null = null;
  public createdAt: string = null;
  public updatedAt: string = null;
}
